// ═══════════════════════════════════════════════════════════════════════════════
// Helper home — scan receipt action card (centered title, background icon)
// ═══════════════════════════════════════════════════════════════════════════════

import { Link } from 'react-router-dom';
import { ScanReceiptNewspaperIcon } from './ScanReceiptNewspaperIcon';

type HelperScanReceiptActionCardProps = {
  title: string;
  hint: string;
  ariaLabel: string;
  to: string;
};

export const HelperScanReceiptActionCard = ({
  title,
  hint,
  ariaLabel,
  to,
}: HelperScanReceiptActionCardProps) => (
  <Link
    to={to}
    aria-label={ariaLabel}
    className="relative flex min-h-[100px] min-w-0 cursor-pointer flex-col overflow-hidden rounded-2xl border border-sky-300 bg-gradient-to-br from-white via-sky-50/80 to-blue-100/70 p-3 text-center shadow-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 dark:border-sky-300 dark:bg-gradient-to-br dark:from-gray-900 dark:via-sky-950/35 dark:to-gray-900"
  >
    <div
      className="pointer-events-none absolute right-4 -top-4 origin-top-right -rotate-[30deg] opacity-[0.55] dark:opacity-80"
      aria-hidden
    >
      <ScanReceiptNewspaperIcon variant="watermark" className="h-[88px] w-[88px] max-w-none" />
    </div>

    <div className="relative z-10 flex min-h-0 flex-1 flex-col">
      <div className="flex flex-1 items-center justify-center">
        <span className="text-sm font-semibold text-gray-900 min-[400px]:text-sm sm:text-sm dark:text-gray-100">
          {title}
        </span>
      </div>
      <p className="shrink-0 text-sm leading-normal text-gray-600 min-[400px]:max-sm:text-[10px] min-[400px]:max-sm:leading-snug sm:text-sm dark:text-gray-200">
        {hint}
      </p>
    </div>
  </Link>
);
